module.exports = __webpack_public_path__ + "img/promoEmas.79e3a9fa.jpeg";